import Draggable from "../Draggable"

export default function FormulaBuilderDragIcon({ id, type, object }) {
  const dragData = {
    type,
    id,
    object,
  }

  return (
    <Draggable id={`${type}_${id}`} data={dragData}>
      <span className="material-icons">{"drag_indicator"}</span>
    </Draggable>
  )
}
